<template>
    <gsc-invoice-common isEdit></gsc-invoice-common>
</template>
<script>
import gscInvoiceCommon from './gscInvoiceCommon'
export default {
    name: 'gscInvoiceEdit',
    components: {
        gscInvoiceCommon
    }
}
</script>